import { network } from 'services/network';

export const getCardsHeaderView = (params) => {
    return network.post('api/bo/getCardsHeaderView', params).then((response) => {
        return response.data;
    });
};
